import { DateTime } from 'luxon';

import { PriceRange } from 'common/api-types/recommendations';
import { formatMoney } from 'common/utils/moneyUtils';

export function getMetricValueUnit() {
  return {
    AVERAGE_BASKET_VALUE: { leftUnit: '€', rightUnit: undefined },
    SELECTION_COUNT: { leftUnit: undefined, rightUnit: undefined },
    PURE_PRODUCT_MARGIN: { leftUnit: undefined, rightUnit: '%' },
    SHRINKAGE: { leftUnit: undefined, rightUnit: '%' },
  };
}

export function getPriceRange(prices: PriceRange, locale: string) {
  const { min, max } = prices;

  if (min.amount === max.amount) {
    return `${formatMoney(locale, min)}`;
  }

  return `${formatMoney(locale, min)} - ${formatMoney(locale, max)}`;
}

export function getListingDuration(listedSince: string, locale: string) {
  const fromIso = DateTime.fromISO(listedSince).setLocale(locale);
  const now = DateTime.now();
  const weeks = Math.floor(now.diff(fromIso, 'weeks').weeks);

  return weeks;
}
